/**
 * Application Configuration
 * Uses Vite environment variables for different environments
 */

// API Base URL - set via environment variable or default to localhost for development
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

// Feature flags
export const ENABLE_MUTANT_CARDS = true; // Set to false to hide Mutant (Fart Club) cards

// NFT Card Game Configuration
export const AOX_CARD_NFT_ISSUER = import.meta.env.VITE_AOX_CARD_ISSUER || '';

// NFTokenTaxon — single taxon so all AOX NFTs appear in one collection on xrp.cafe
export const NFT_TAXON = 1;

// Export individual service URLs if needed
export const config = {
  apiUrl: API_BASE_URL,
  ENABLE_MUTANT_CARDS,
  AOX_CARD_NFT_ISSUER,
  NFT_TAXON,
};

export default config;
